import React from 'react';

import { defineMessages, FormattedMessage } from 'react-intl-next';

import Flag from '@atlaskit/flag';
import { fg } from '@atlaskit/platform-feature-flags';
import { TeamsAnchor } from '@atlaskit/teams-app-internal-navigation/teams-anchor';
import { Anchor } from '@atlassian/ptc-common';

import { flagIconByType } from './utils';

const GenericErrorFlag = (props: { key: string; id: string }): React.JSX.Element => (
	<Flag
		{...props}
		icon={flagIconByType.error}
		title={<FormattedMessage {...messages.title} />}
		description={<FormattedMessage {...messages.description} />}
		actions={[
			{
				content: fg('ptc-react-router-dom-links-migration') ? (
					<TeamsAnchor href="https://getsupport.atlassian.com/" intent="reference">
						<FormattedMessage {...messages.link} />
					</TeamsAnchor>
				) : (
					<Anchor href="https://getsupport.atlassian.com/" target="_blank">
						<FormattedMessage {...messages.link} />
					</Anchor>
				),
			},
		]}
	/>
);

const messages = defineMessages({
	title: {
		id: 'ptc-directory.profile.flags.generic-error-flag.title',
		defaultMessage: 'Something went wrong',
		description: 'Title of flag shown when there was a generic error',
	},
	description: {
		id: 'ptc-directory.profile.flags.generic-error-flag.description',
		defaultMessage:
			'Refresh the page and try again. If this keeps happening, let us know using the link below.',
		description: 'Body of flag shown when there was a generic error',
	},
	link: {
		id: 'ptc-directory.profile.flags.generic-error-flag.link',
		defaultMessage: 'Visit Atlassian support',
		description: 'Link text in flag shown when there was a generic error',
	},
});

export default GenericErrorFlag;
